import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: { name: 'Courses' },
    meta: {
      public: true,
    },
  },
  {
    path: '/courses',
    name: 'Courses',
    component: () => import('../views/Courses.vue'),
    meta: {
      public: true,
    },
  },
  {
    path: '/courses/:courseId',
    name: 'Course',
    component: () => import('../views/Course.vue'),
    meta: {
      public: true,
    },
  },
  {
    path: '/subscribe/:courseId',
    name: 'Subscribe',
    component: () => import('../views/Subscribe.vue'),
    meta: {
      public: true,
    },
  },
  {
    path: '/subscriptions',
    name: 'Subscriptions',
    component: () => import('../views/Subscriptions.vue'),
  },
  {
    path: '/courses/:courseId/confirmed',
    name: 'SubscriptionConfirmed',
    component: () => import('../views/SubscriptionConfirmed.vue'),
  },
  {
    path: '/subscriptions/:subscriptionId',
    name: 'Subscription',
    component: () => import('../views/Subscription.vue'),
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/Profile.vue'),
  },
  {
    path: '/sign_in',
    name: 'SignIn',
    component: () => import('../views/SignIn.vue'),
    meta: {
      public: true,
    },
  },
  {
    path: '/password-forgotten',
    name: 'PasswordForgotten',
    component: () => import('../views/PasswordForgotten.vue'),
    meta: {
      public: true,
    },
  },
  {
    path: '/new-password',
    name: 'NewPassword',
    component: () => import('../views/NewPassword.vue'),
    meta: {
      public: true,
    },
  },
  {
    path: '/sign_up',
    name: 'SignUp',
    component: () => import('../views/SignUp.vue'),
    meta: {
      public: true,
    },
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: () => import('../views/Maintenance.vue'),
    meta: {
      public: true,
    },
  },
  {
    path: '/confirmation-email-sent',
    name: 'ConfirmationEmailSent',
    component: () => import('../views/ConfirmationEmailSent.vue'),
    meta: {
      public: true,
    },
  },
  {
    path: '/cas-callback',
    name: 'CasCallback',
    component: () => import('../views/CasCallback.vue'),
    meta: {
      public: true,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
